import { redirectToLogin } from '@ynap/redirect-utils';
import setUser from './setUser';
import { FETCH_USER_FROM_SF_SUCCESS, FETCH_USER_FROM_SF_ERROR } from '../constants/ActionTypes';

export function fetchUserSuccess() {
    return {
        type: FETCH_USER_FROM_SF_SUCCESS,
    };
}

export function fetchUserError() {
    return {
        type: FETCH_USER_FROM_SF_ERROR,
    };
}

export default function fetchUserFromSF(forceLogin = false, additionalLoginParams = {}) {
    return (dispatch, getState) => {
        const {
            appState: { locale },
            config: { head: { redirects: { loginUrlTemplate } = {} } = {} } = {},
        } = getState();

        if (!window.SF) return redirectToLogin(locale);

        return window.SF.getUserSummary()
            .then((user) => {
                if (forceLogin) {
                    // Legacy NAP user not signed in is not returned as null but with status === NOT_SIGNED_IN
                    if (!user || (user.status && user.status !== 'SIGNED_IN' && user.status !== 'REMEMBERED')) {
                        dispatch(fetchUserError());
                        return redirectToLogin(locale, additionalLoginParams, loginUrlTemplate);
                    }
                }

                if (user) {
                    dispatch(fetchUserSuccess());
                    return dispatch(setUser(user));
                } else {
                    return dispatch(fetchUserError());
                }
            })
            .catch((e) => {
                dispatch(fetchUserError());
                return e; // TODO: fire error to raygun/clientside-monitoring
            });
    };
}
